// Mock data for Green Source Fuels website

export const companyInfo = {
  name: "Green Source Fuels",
  tagline: "Your Trusted Petroleum Partner in Southern Africa",
  description: "A Level 1 B-BBEE owned company specializing in wholesale diesel sales and distribution across the SADC region.",
  established: "2020",
  phone: ["+27 73 914 2771", "+27 71 675 1440"],
  email: "sales@greensourcefuels.co.za",
  address: {
    street: "29 North Reef Road",
    area: "Elandsfontein Rail",
    city: "Jet Park",
    province: "Gauteng",
    postalCode: "1459",
    country: "South Africa"
  },
  addresses: [
    {
      label: "Main Distribution Depot",
      street: "29 North Reef Road",
      area: "Elandsfontein Rail",
      city: "Jet Park",
      province: "Gauteng",
      postalCode: "1459",
      country: "South Africa"
    },
    {
      label: "Express Service Depot",
      street: "143 Springs Road",
      area: "",
      city: "Brakpan",
      province: "Gauteng",
      postalCode: "",
      country: "South Africa"
    }
  ]
};

export const heroContent = {
  title: "Powering Africa's Growth with Quality Petroleum Solutions",
  subtitle: "Leading wholesale diesel supplier serving logistics, mining, and farming industries across Southern Africa",
  cta: "Request a Quote",
  secondaryCta: "Our Services"
};

export const products = [
  {
    id: 1,
    name: "Diesel 50ppm",
    category: "Petroleum",
    description: "High-quality low-sulfur diesel for industrial and commercial use",
    applications: ["Heavy machinery", "Transport fleets", "Mining equipment"]
  },
  {
    id: 2,
    name: "Diesel 10ppm",
    category: "Petroleum",
    description: "Ultra-low sulfur diesel meeting latest environmental standards",
    applications: ["Modern diesel engines", "Eco-friendly operations"]
  },
  {
    id: 3,
    name: "Petrol ULP95",
    category: "Petroleum",
    description: "Premium unleaded petrol for optimal engine performance",
    applications: ["Passenger vehicles", "Light commercial vehicles"]
  },
  {
    id: 4,
    name: "Petrol ULP93",
    category: "Petroleum",
    description: "Standard unleaded petrol for everyday use",
    applications: ["General transport", "Fleet vehicles"]
  },
  {
    id: 5,
    name: "Jet Fuel / Aviation Gasoline",
    category: "Petroleum",
    description: "Aviation-grade fuel for aircraft operations",
    applications: ["Commercial aviation", "Private aircraft"]
  },
  {
    id: 6,
    name: "Paraffin (Dual Purpose Kerosene)",
    category: "Petroleum",
    description: "Versatile fuel for heating and lighting applications",
    applications: ["Heating systems", "Industrial processes"]
  }
];

export const services = [
  {
    id: 1,
    title: "Wholesale Fuel Supply",
    description: "Bulk petroleum products on contractual or ad-hoc basis with guaranteed quality and availability",
    icon: "Fuel"
  },
  {
    id: 2,
    title: "Transportation & Logistics",
    description: "Safe and efficient fuel transportation with our fleet, ensuring timely delivery across Southern Africa",
    icon: "Truck"
  },
  {
    id: 3,
    title: "Fuel Storage Solutions",
    description: "Professional storage facilities with proper handling and transshipping capabilities",
    icon: "Warehouse"
  },
  {
    id: 4,
    title: "Storage Facility Setup",
    description: "Expert consulting for installation and setup of compliant fuel storage infrastructure",
    icon: "Settings"
  },
  {
    id: 5,
    title: "Maintenance Services",
    description: "Ongoing maintenance and support for your storage infrastructure",
    icon: "Wrench"
  },
  {
    id: 6,
    title: "Compliance Consulting",
    description: "Guidance on regulatory requirements and compliance for fuel storage facilities",
    icon: "Shield"
  }
];

export const industries = [
  {
    id: 1,
    name: "Logistics & Transportation",
    description: "Reliable fuel supply for transport fleets, ensuring your operations never stop",
    icon: "TruckIcon",
    image: "/images/logistics-fleet.png",
    benefits: ["Consistent supply", "Competitive pricing", "Flexible delivery", "Fleet card programs"]
  },
  {
    id: 2,
    name: "Mining Operations",
    description: "Bulk diesel supply for mining equipment and operations across Southern Africa",
    icon: "Pickaxe",
    image: "/images/mining-operation.png",
    benefits: ["Large volume capacity", "Remote site delivery", "24/7 support", "On-site storage solutions"]
  },
  {
    id: 3,
    name: "Agriculture & Farming",
    description: "Fuel solutions for farming equipment and agricultural operations",
    icon: "Tractor",
    image: "/images/agriculture-tractor.png",
    benefits: ["Seasonal flexibility", "Farm gate delivery", "Custom contracts", "Bulk discounts"]
  },
  {
    id: 4,
    name: "Construction & Earthmoving",
    description: "Powering construction sites with reliable diesel for heavy machinery",
    icon: "HardHat",
    image: "/images/construction-site.png",
    benefits: ["Site delivery", "Quick refueling", "Project-based pricing", "Equipment fuel cards"]
  },
  {
    id: 5,
    name: "Marine & Maritime",
    description: "Bunkering services and fuel supply for ports, ships, and fishing fleets",
    icon: "Ship",
    image: "/images/marine-port.png",
    benefits: ["Port-side delivery", "Marine-grade fuel", "Bulk bunkering", "Quality compliance"]
  },
  {
    id: 6,
    name: "Aviation Ground Operations",
    description: "Aviation fuel supply for airports, ground support, and private aircraft",
    icon: "Plane",
    image: "/images/aviation-fuel.png",
    benefits: ["Jet A1 supply", "Airport delivery", "Quality assured", "Regulatory compliant"]
  },
  {
    id: 7,
    name: "Power Generation",
    description: "Diesel for backup generators, off-grid power, and industrial generators",
    icon: "Zap",
    image: "/images/power-generation.png",
    benefits: ["Emergency supply", "Long-term contracts", "Standby support", "Storage solutions"]
  },
  {
    id: 8,
    name: "Manufacturing & Industrial",
    description: "Industrial fuel supply for factories, processing plants, and heavy industry",
    icon: "Factory",
    image: "/images/manufacturing-facility.png",
    benefits: ["Bulk supply", "Scheduled deliveries", "Multiple products", "Cost optimization"]
  },
  {
    id: 9,
    name: "Retail Fuel Stations",
    description: "Wholesale supply to independent and branded retail filling stations",
    icon: "Fuel",
    image: "/images/retail-station.png",
    benefits: ["Competitive wholesale prices", "Regular deliveries", "Multiple grades", "Brand partnerships"]
  },
  {
    id: 10,
    name: "Government & Municipal",
    description: "Fuel supply for government fleets, public services, and municipal operations",
    icon: "Building2",
    image: "/images/municipal-office.png",
    benefits: ["Tender compliance", "Transparent pricing", "B-BBEE certified", "Audit ready"]
  },
  {
    id: 11,
    name: "Oil & Gas Sector",
    description: "Supporting upstream and downstream operations with quality fuel products",
    icon: "Droplet",
    image: "/images/fuel-storage-tanks.png",
    benefits: ["Industry expertise", "High-grade products", "Compliance support", "Reliable supply"]
  }
];

export const tradeHistory = [
  {
    year: "2020",
    title: "Company Establishment",
    description: "Green Source Fuels founded as Level 1 B-BBEE company with wholesale license from Department of Energy"
  },
  {
    year: "2020",
    title: "First Major Contract",
    description: "Secured inaugural contract valued at R25 Million for Diesel 50ppm supply"
  },
  {
    year: "2021",
    title: "Service Expansion",
    description: "Expanded operations to include logistics services and storage solutions"
  },
  {
    year: "2022",
    title: "Regional Growth",
    description: "Extended supply network across SADC region including Zambia and Zimbabwe"
  },
  {
    year: "2023",
    title: "Multiple Contracts",
    description: "Secured second and third major contracts in mining and logistics sectors"
  },
  {
    year: "2024",
    title: "Strategic Partnerships",
    description: "Direct loading agreements with Shell, Engen & BP for quality assurance"
  }
];

export const clients = [
  {
    id: 1,
    name: "Major Logistics Company",
    industry: "Logistics",
    testimonial: "Green Source Fuels has been our reliable partner for diesel supply. Their service delivery is exceptional."
  },
  {
    id: 2,
    name: "Mining Corporation",
    industry: "Mining",
    testimonial: "Consistent quality and timely delivery have made them our preferred fuel supplier for all mining operations."
  },
  {
    id: 3,
    name: "Agricultural Holdings",
    industry: "Farming",
    testimonial: "Their flexible contracts and farm gate delivery service have significantly improved our operational efficiency."
  }
];

export const targetMarkets = [
  { country: "South Africa", status: "Established" },
  { country: "Zambia", status: "Regional Subsidiary" },
  { country: "Zimbabwe", status: "Regional Subsidiary" },
  { country: "Namibia", status: "Regional Subsidiary" },
  { country: "Mozambique", status: "Import Partner" },
  { country: "UAE", status: "International Subsidiary" }
];

// Regional and International Subsidiaries for cross-jurisdictional trade
export const sisterCompanies = [
  {
    country: "Namibia",
    flag: "🇳🇦",
    role: "Regional Subsidiary",
    description: "Facilitating trade and distribution across Namibia and Southern African routes"
  },
  {
    country: "Zimbabwe",
    flag: "🇿🇼",
    role: "Regional Subsidiary",
    description: "Local presence ensuring seamless fuel supply across Zimbabwe"
  },
  {
    country: "Zambia",
    flag: "🇿🇲",
    role: "Regional Subsidiary",
    description: "Strategic partner for Zambian mining and logistics operations"
  },
  {
    country: "Mozambique",
    flag: "🇲🇿",
    role: "Import Partner",
    description: "Coastal access via Maputo port enabling efficient regional import distribution"
  },
  {
    country: "United Arab Emirates",
    flag: "🇦🇪",
    role: "International Subsidiary",
    description: "Middle East gateway providing direct access to global petroleum markets"
  }
];

export const values = [
  {
    title: "Business Integrity",
    description: "Operating with transparency and honesty in all transactions"
  },
  {
    title: "Good Faith Trading",
    description: "Building relationships based on trust and mutual respect"
  },
  {
    title: "Performance Excellence",
    description: "Delivering exceptional results consistently"
  },
  {
    title: "Absolute Service Delivery",
    description: "Committed to meeting and exceeding client expectations"
  }
];

export const vision = "To be a preferred wholesale diesel supplier in the SADC region, and eventually the entire African Continent. To be recognized as a preferred service provider and supplier of Petroleum Products in all our markets by 2030.";

export const mission = "To become a long-term formidable competitor in the Petroleum industry. To earn unquestionable Trust amongst all our clients and participate in the upliftment of all communities that we operate in.";

export const whyChooseUs = [
  {
    title: "Product Availability",
    description: "Consistent stock levels and reliable supply chain"
  },
  {
    title: "Dependable & Speedy Service",
    description: "Fast response times and efficient delivery"
  },
  {
    title: "Attention to Detail",
    description: "Meticulous approach to quality and safety"
  },
  {
    title: "Quality Assurance",
    description: "High-quality, uncontaminated fuel loaded directly from Shell, Engen & BP"
  },
  {
    title: "Responsive Customer Care",
    description: "Dedicated support team and after-sales service"
  },
  {
    title: "Licensed & Compliant",
    description: "Valid wholesale license with unblemished record"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Fuel Quality Standards in Southern Africa",
    excerpt: "Understanding the importance of fuel quality in industrial operations...",
    date: "2024-01-15",
    category: "Industry Insights"
  },
  {
    id: 2,
    title: "Expanding Operations into SADC Region",
    excerpt: "Our strategic growth across Zambia, Zimbabwe, and beyond...",
    date: "2024-02-20",
    category: "Company News"
  },
  {
    id: 3,
    title: "Sustainable Fuel Solutions for Mining",
    excerpt: "How we support the mining industry with reliable fuel supply...",
    date: "2024-03-10",
    category: "Solutions"
  }
];

// Pricing data for South African and International fuel prices
export const currentPrices = {
  lastUpdated: "December 2026",
  southAfrica: [
    { product: "Diesel 50ppm", price: 23.45, unit: "R/Litre", change: -0.45, region: "Coastal" },
    { product: "Diesel 50ppm", price: 24.12, unit: "R/Litre", change: -0.45, region: "Inland" },
    { product: "Diesel 10ppm", price: 23.78, unit: "R/Litre", change: -0.42, region: "Coastal" },
    { product: "Diesel 10ppm", price: 24.45, unit: "R/Litre", change: -0.42, region: "Inland" },
    { product: "Petrol ULP95", price: 22.89, unit: "R/Litre", change: 0.28, region: "Coastal" },
    { product: "Petrol ULP95", price: 23.56, unit: "R/Litre", change: 0.28, region: "Inland" },
    { product: "Petrol ULP93", price: 22.34, unit: "R/Litre", change: 0.28, region: "Inland" },
    { product: "Paraffin", price: 16.78, unit: "R/Litre", change: -0.15, region: "Wholesale" },
    { product: "Jet Fuel A1", price: 21.45, unit: "R/Litre", change: 0.32, region: "Aviation" }
  ],
  international: [
    { product: "Brent Crude Oil", price: 78.45, unit: "USD/Barrel", change: 1.23 },
    { product: "WTI Crude Oil", price: 74.32, unit: "USD/Barrel", change: 0.98 },
    { product: "Diesel (Gasoil)", price: 745.50, unit: "USD/MT", change: -5.20 },
    { product: "Jet Fuel", price: 825.30, unit: "USD/MT", change: 3.45 },
    { product: "Naphtha", price: 612.40, unit: "USD/MT", change: -2.15 },
    { product: "Fuel Oil", price: 485.60, unit: "USD/MT", change: -1.85 }
  ]
};

// Monthly price trends (last 6 months)
export const priceTrends = {
  diesel50ppm: [
    { month: "Jul", price: 22.85 },
    { month: "Aug", price: 23.10 },
    { month: "Sep", price: 23.45 },
    { month: "Oct", price: 23.80 },
    { month: "Nov", price: 23.90 },
    { month: "Dec", price: 23.45 }
  ],
  petrol95: [
    { month: "Jul", price: 22.30 },
    { month: "Aug", price: 22.55 },
    { month: "Sep", price: 22.78 },
    { month: "Oct", price: 22.95 },
    { month: "Nov", price: 22.61 },
    { month: "Dec", price: 22.89 }
  ],
  brentCrude: [
    { month: "Jul", price: 75.20 },
    { month: "Aug", price: 76.45 },
    { month: "Sep", price: 77.80 },
    { month: "Oct", price: 79.20 },
    { month: "Nov", price: 77.22 },
    { month: "Dec", price: 78.45 }
  ]
};

// FAQ for the chatbot - rule-based responses
export const fuelFAQs = [
  {
    question: "What is the current diesel price in South Africa?",
    answer: "Current Diesel 50ppm prices are approximately R23.45/Litre (Coastal) and R24.12/Litre (Inland). Prices are updated monthly based on Department of Energy adjustments and international oil prices."
  },
  {
    question: "What fuel products do you supply?",
    answer: "We supply Diesel 50ppm, Diesel 10ppm, Petrol ULP95, Petrol ULP93, Jet Fuel/Aviation Gasoline, and Paraffin (Dual Purpose Kerosene). All products are loaded directly from Shell, Engen & BP for guaranteed quality."
  },
  {
    question: "Do you deliver to Zambia and Zimbabwe?",
    answer: "Yes, we have Regional Subsidiaries in Zambia, Zimbabwe, and Namibia, an Import Partner in Mozambique, and an International Subsidiary in UAE. This cross-border network enables seamless trade facilitation and efficient fuel distribution across multiple jurisdictions in Southern Africa and the Middle East."
  },
  {
    question: "What is the minimum order quantity?",
    answer: "Minimum order quantities vary by product and delivery location. For bulk wholesale, we typically supply from 5,000 litres upwards. Contact our sales team for specific requirements at sales@greensource.co.za."
  },
  {
    question: "How are fuel prices determined in South Africa?",
    answer: "Fuel prices in South Africa are regulated by the Department of Energy and adjusted monthly based on: international oil prices (Brent Crude), Rand/USD exchange rate, fuel levy, RAF levy, and other government charges. Prices change on the first Wednesday of each month."
  },
  {
    question: "What is B-BBEE Level 1 certification?",
    answer: "Level 1 B-BBEE (Broad-Based Black Economic Empowerment) is the highest certification level in South Africa, indicating maximum compliance with empowerment criteria. As a Level 1 contributor, we provide procurement recognition of 135% to our clients."
  },
  {
    question: "Do you offer fuel storage solutions?",
    answer: "Yes, we provide comprehensive storage services including: setup & installation of storage facilities, maintenance of storage infrastructure, compliance consulting, and transshipping & handling of fuels."
  },
  {
    question: "How long does delivery take?",
    answer: "Delivery times depend on location and quantity. Standard deliveries within Gauteng take 24-48 hours. For remote locations or large quantities, we coordinate with you to schedule optimal delivery times."
  },
  {
    question: "What payment terms do you offer?",
    answer: "We offer flexible payment terms including upfront payment, 30-day credit (subject to credit approval), and contractual arrangements for established clients. Contact our finance team for specific terms."
  },
  {
    question: "How can I get a quote?",
    answer: "You can request a quote through our website's 'Request Quote' form, email us at sales@greensourcefuels.co.za, or call +27 73 914 2771. Please provide: product type, quantity, delivery location, and frequency for accurate pricing."
  }
];

// Sectors expanded list (for full sectors page)
export const expandedSectors = [
  "Logistics & Transportation",
  "Mining Operations (Coal, Gold, Platinum, Iron Ore)",
  "Agriculture & Farming",
  "Construction & Earthmoving",
  "Marine & Maritime (Ports, Fishing, Shipping)",
  "Aviation Ground Operations",
  "Power Generation (Industrial, Backup, Off-grid)",
  "Manufacturing & Industrial",
  "Retail Fuel Stations",
  "Government & Municipal Fleets",
  "Oil & Gas Sector",
  "Quarrying & Aggregates",
  "Healthcare & Emergency Services",
  "Education & Public Transport",
  "Hospitality & Tourism",
  "Telecommunications (Tower Power)",
  "Data Centers"
];